import {useState, useEffect} from "react";
import {GeneratedSerial} from "../components/GeneratedSerial";
import {connectQZTray, getPrinters} from "../utils/qzHelper";
import MainLayout from "../components/MainLayout";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import {ProgressSpinner} from "primereact/progressspinner";
import {InputText} from "primereact/inputtext";
import {BreadCrumb} from "primereact/breadcrumb";
import {getVipusks} from "../services/vipusk.service";
import {Paginator} from "primereact/paginator";

const GeneratedSerialsPage = () => {
	const [printers, setPrinters] = useState([]);
	const [selectedPrinter, setSelectedPrinter] = useState("");
	const [serials, setSerials] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [searchText, setSearchText] = useState("");
	const [totalRecords, setTotalRecords] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(20);
	const [filteredSerials, setFilteredSerials] = useState();

	console.log(error);

	useEffect(() => {
		searchFunc();
	}, [searchText]);

	const searchFunc = () =>
		setFilteredSerials(
			serials.filter(
				(serial) =>
					serial.unique?.name
						?.toLowerCase()
						.includes(searchText.toLowerCase()) ||
					(Array.isArray(serial.demand_furniture) &&
						serial.demand_furniture.some((df) =>
							df.demand?.doc_no
								?.toLowerCase()
								.includes(searchText.toLowerCase())
						))
			)
		);

	const handlePrinterChange = (e) => {
		const printer = e.target.value;
		setSelectedPrinter(printer);
		localStorage.setItem("selectedPrinter", printer);
	};

	const initializeQZTray = async () => {
		try {
			await connectQZTray();
			const availablePrinters = await getPrinters();
			setPrinters(availablePrinters);
			const savedPrinter = localStorage.getItem("selectedPrinter");
			if (savedPrinter && availablePrinters.includes(savedPrinter)) {
				setSelectedPrinter(savedPrinter);
			}
		} catch (err) {
			setError(
				"QZ Tray билан боғланиш ёки принтерларни олишда хатолик юз берди."
			);
		} finally {
			setLoading(false);
		}
	};

	const fetchGeneratedSerials = async (page) => {
		setLoading(true);
		try {
			const invoices = await getVipusks(page);
			setSerials(invoices.data);
			setFilteredSerials(invoices.data);
			setTotalRecords(invoices.total);
		} catch (error) {
			toast.error("Серия рақамлари кўрсатишда хатолик");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		initializeQZTray();
	}, []);

	useEffect(() => {
		fetchGeneratedSerials(currentPage);
	}, [currentPage]);

	const item = [
		{
			label: "Серия рақамлар",
			template: () => <span className="cursor-pointer">Серия рақамлар</span>,
		},
	];

	return (
		<MainLayout header="Яратилган серия рақамлар">
			<div className="px-4 mx-auto">
				{<BreadCrumb model={item} className="px-0 pt-0 mb-6" />}
				<div className="flex items-end justify-between mb-6">
					<div>
						<h2 className="text-lg font-bold">Принтерни танлаш</h2>
						<select
							value={selectedPrinter}
							onChange={handlePrinterChange}
							className="p-2.5 mt-2 border rounded-lg">
							<option value="">Принтерни танлаш</option>
							{printers.map((printer, index) => (
								<option key={index} value={printer}>
									{printer}
								</option>
							))}
						</select>
					</div>
					<div className="relative w-full mx-4">
						<i className="absolute text-gray-400 -translate-y-1/2 pi pi-search left-3 top-1/2" />
						<InputText
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
							placeholder="Накладной рақами..."
							className="w-full py-2 pb-[4px] pl-9 pr-4 border"
						/>
					</div>

					<Link to="/generation">
						<button className="w-full px-4 py-2.5 text-white rounded-md bg-blue hover:bg-opacity-90 whitespace-nowrap">
							Янги серия рақам олиш
						</button>
					</Link>
				</div>
				{loading ? (
					<div className="flex justify-center my-10">
						<ProgressSpinner />
					</div>
				) : filteredSerials.length ? (
					<>
						{filteredSerials.map((serial) => (
							<GeneratedSerial
								key={serial.id}
								serial={serial}
								selectedPrinter={selectedPrinter}
							/>
						))}
						<Paginator
							className="mb-4"
							first={(currentPage - 1) * rowsPerPage}
							rows={rowsPerPage}
							totalRecords={totalRecords}
							onPageChange={(e) => {
								setCurrentPage(e.page + 1);
							}}
						/>
					</>
				) : (
					<div className="text-center text-gray-600">
						Серия номерлари яратилмаган
					</div>
				)}
			</div>
		</MainLayout>
	);
};

export default GeneratedSerialsPage;
